export class Lookup {
	$id: number;
	Code: string;
	CodeDescription: string;
	Default: boolean;
	Id: string;
	DF_ID: number;
	Sequence: number;
	StateIdentifier: string;
	State: string;
	UseInReferral: boolean;
	ValidActionCodes: string;
	CodeDesc: string;
	SchoolId: number;
	LastRunByDate: Date;
	LastRunByUser: string;
	SubCodeId: number;
	IncidentCodeId: number;
	IncidentTypeId: number;
	DelStatus: boolean;
	PermissionCategory: string;
	Inactive: boolean;

	// Non=DTO properties
	IsCritical: boolean;
	IsSelected: boolean;
}

export class SiteLookup {
	Id: number;
	Name: string;
	Code: string;
}

export class DistrictLookup {
	Id: number;
	Name: string;
	ExternalDistrict: boolean;
}

export class HealthLookupEnum {

	static  timePeriod = 'sys_TimePeriod';
  	static natureOfInjury =  'sys_NatureOfInjury';
  	static location  = 'sys_Location';
	static medicationsDoseOrders  = 'sys_MedicationsDoseOrders';
  	static medicationType  = 'sys_MedicationType';
  	static screeningResults  = 'sys_ScreeningResults';
  	static audiologicalReferralIndicated  = 'sys_AudiologicalReferralIndicated';
  	static diagnosis  = 'sys_Diagnosis';
  	static screeningReferralStatus  = 'sys_ScreeningReferralStatus';
  	static screeningType  = 'sys_ScreeningType';
  	static screeningSeries  = 'sys_ScreeningSeries';
  	static hearingSensitivityResults  = 'sys_Hearing_Sensitivity_Results';
  	static parentContact  = 'sys_ParentContact';
  	static referralDiagnosisHearing  = 'sys_ReferralDiagnosis_Hearing';
  	static referralTreatmentHearing  = 'sys_ReferralTreatment_Hearing';
  	static monitorAudiogram  = 'sys_MonitorAudiogram';
  	static meetsCriteriaforReferral  = 'sys_MeetsCriteriaforReferral';
  	static referralDiagnosisSpinal  = 'sys_ReferralDiagnosis_Spinal';
  	static referralTreatmentSpinal  = 'sys_ReferralTreatment_Spinal';
  	static continueObservation  = 'sys_ContinueObservation';
  	static visionComprehensiveEyeExam  = 'sys_Vision_ComprehensiveEyeExam';
  	static yN_codes  = 'sys_YN_Codes';
  	static visionGlassesReferral  = 'sys_Vision_GlassesReferral';
  	static medicalStatus = 'sys_Medical_Status';
  	static medicalTestingCodes = 'sys_Medical_TestingCodes';
  	static visionStudentStatus = 'sys_Vision_StudentStatus';
    static medicationCodes = 'sys_MedicationCodes';
	static medicationRoutes = 'sys_MedicationRoutes';
	static clinicVisitReason = 'sys_HealthClinicVisitCodes';
	static clinicVisitNoShow = 'sys_HealthClinicVisitNoShow';
	static clinicVisitDOHSurveillance = 'sys_HealthClinicLogDOHSurveillance';
	static clinicTreatements = 'sys_ClinicTreatements';
	static clinicStudentSentTo = 'sys_ClinicStudentSentTo';

}
